// src/components/Select/PRZSelect.jsx
import React from "react";
import { Select } from "antd";
import PropTypes from "prop-types";
import "./style.scss";

const { Option } = Select;

const PRZSelect = ({
  value,
  options,
  placeholder,
  size = "middle",
  mode,
  allowClear = false,
  defaultValue,
  onChange,
  className,
  wrapperClassName,
  showSearch,
  filterOption,
  style,
  maxTagCount,
  disabled = false,
  labelInValue = false,
  loading = false,
  virtual = true,
  onSearch,
  onFocus,
  onBlur,
  notFoundContent,
  optionFilterProp = "label",
  optionLabelProp,
  dropdownRender,
  tagRender,
  maxTagTextLength,
  suffixIcon,
  showError,
  errorName,
  errorClassName,
  onClear,
  bordered,
  ...rest
}) => {
  return (
    <div className={`prz-select__wrapper ${wrapperClassName ? wrapperClassName : ''}`}>
      <Select
        value={value === null || value === '' ? undefined : value}
        bordered={bordered}
        options={options}
        placeholder={placeholder}
        size={size}
        mode={mode}
        allowClear={allowClear}
        defaultValue={defaultValue}
        showSearch={showSearch}
        filterOption={
          filterOption ??
          ((input, option) =>
            (option?.label ?? "")?.toLowerCase()?.includes(input?.toLowerCase()))
        }
        onChange={onChange}
        className={`${className} prz-custom-select`}
        style={style}
        maxTagCount={maxTagCount}
        disabled={disabled}
        labelInValue={labelInValue}
        loading={loading}
        virtual={virtual}
        onSearch={onSearch}
        onFocus={onFocus}
        onBlur={onBlur}
        notFoundContent={notFoundContent}
        optionFilterProp={optionFilterProp}
        optionLabelProp={optionLabelProp}
        dropdownRender={dropdownRender}
        tagRender={tagRender}
        maxTagTextLength={maxTagTextLength}
        suffixIcon={suffixIcon}
        onClear={onClear}
        {...rest}
      >
        {rest?.children
          ? rest?.children
          : options?.length
            ? options?.map((option) => (
              <Option
                key={option?.value}
                value={option?.value}
                label={option?.label}
                disabled={option?.disabled}
              >
                <div className="flex-display flex-align-c prz-custom-select__option">
                  {option?.label}
                  &nbsp;{" "}
                  {option?.tag && (
                    <span className="prz-custom-select__option-left">{option?.tag}</span>
                  )}
                </div>
              </Option>
            ))
            : null}
      </Select>
      {showError && (
        <div className={errorClassName}>
          *Please select {errorName}
        </div>
      )}
    </div>
  );
};

// Prop Types for validation
PRZSelect.propTypes = {
  value: PropTypes.any,
  defaultValue: PropTypes.any,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      label: PropTypes.string.isRequired,
      tag: PropTypes.string,
    })
  ).isRequired,
  placeholder: PropTypes.string,
  size: PropTypes.oneOf(["small", "middle", "large"]),
  mode: PropTypes.oneOf(["default", "multiple", "tags"]),
  allowClear: PropTypes.bool,
  style: PropTypes.object,
  showSearch: PropTypes.bool,
  filterOption: PropTypes.func,
  maxTagCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  disabled: PropTypes.bool,
  labelInValue: PropTypes.bool,
  loading: PropTypes.bool,
  virtual: PropTypes.bool,
  onChange: PropTypes.func,
  onSearch: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  notFoundContent: PropTypes.node,
  optionFilterProp: PropTypes.string,
  optionLabelProp: PropTypes.string,
  dropdownRender: PropTypes.func,
  tagRender: PropTypes.func,
  maxTagTextLength: PropTypes.number,
  suffixIcon: PropTypes.node,
  className: PropTypes.string,
  wrapperClassName: PropTypes.string,
  showError: PropTypes.bool,
  errorName: PropTypes.string,
};

// Default Props
PRZSelect.defaultProps = {
  placeholder: "",
  size: "middle",
  mode: "default",
  allowClear: false,
  defaultValue: undefined,
  onChange: () => { },
  className: "",
};

export default PRZSelect;
